export function registerPerformanceWorker() {
  if (process.env.NODE_ENV !== "production" || !window.isSecureContext || !("serviceWorker" in navigator)) return;
  const register = async () => {
    try {
      const registration = await navigator.serviceWorker.register("/sw.js", { scope: "/", updateViaCache: "none" });
      // Check on launch, but never take over or reload a running performance.
      void registration.update().catch(() => {});
    } catch (error) {
      console.warn("Offline setup unavailable; the VJ continues online.", error);
    }
  };
  if (document.readyState === "complete") void register();
  else window.addEventListener("load", register, { once: true });
}
